(function ($) {
  "use strict";
  $(document).ready(function () {
    wrapForms();

    /* tba
    const tabResults = $(".show-filter__button");

    // on click of the show filter button add `show-filter__button--current` class and remove it from the other buttons
    tabResults.click(function (e) {
      e.preventDefault();

      if ($(this).hasClass("show-filter__button--current")) {
        return;
      }

      tabResults.removeClass("show-filter__button--current");
      $(this).addClass("show-filter__button--current");

      // submit the form and
      const resultContainer = $(".results-wrapper");

      resultContainer.html('<div class="loader"></div>');

      const form = $(this).closest("form");
      const formData = form.serialize();

      $.ajax({
        type: "POST",
        url: form.attr("action"),
        data: formData,
        success: function (data) {
          if (data) {
            resultContainer.html(data);
          }
        },
      });
    });
    */
  });
})(jQuery);

function wrapForms() {
  $("form.userform").each(function (i) {
    if (!$(this).parent().hasClass("form-holder")) {
      $(this).wrap('<div class="form-holder"></div>');
    }
  });
}
